//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Typography } from '@backmarket/design-system'

import translations from '../../../../Internal.translations'
import RatingIcons from '../../../RatingIcons'

export default {
  components: {
    RatingIcons,
    Typography,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    rate: {
      type: Number,
      default: null,
    },
  },
  computed: {
    label() {
      return this.$t(this.translationsByKey[this.name])
    },
    translationsByKey() {
      return {
        review_accessories: translations.accessoriesTitle,
        review_aesthetic_appearance: translations.aestheticAppearanceTitle,
        review_battery: translations.batteryTitle,
        review_camera: translations.cameraTitle,
        review_main: translations.mainTitle,
        review_overall_performance: translations.overallPerformanceTitle,
        review_packaging_cleanliness: translations.packagingCleanlinessTitle,
        review_shipping: translations.shippingTitle,
      }
    },
  },
}
